import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { logout } from '@/api/login'

import router from '@/router'

axios.defaults.headers['flag'] = 'teach';
const service = axios.create({
  // timeout: 600000 // request timeout
});

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['mechanismToken'] = getToken();
      // config.headers['flag'] = 'teach';
    }
    return config
  },
  error => {
    console.log(error);
    Promise.reject(error)
  }
);

service.interceptors.response.use(
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data;
    if (res.code === 100000) {
      return res
    } else if (res.code === undefined) {
      return response
    } else {
      switch (res.code) {
        case 100202 :
          showMessage('用户不存在');
          break;
        case 100208 :
          showMessage('token失效');
          setTimeout(function () {
            store.dispatch('FedLogOut').then(() => {
              location.reload()
            },1500);
          });
          break;
        case 100999 :
          showMessage('系统错误');
          break;
        case 100205 :
          showMessage('用户已存在');
          break;
        case 100001 :
          showMessage('操作失败');
          break;
        case 200003 :
          setTimeout(function () {
            showMessage('用户信息失效,请登录')
            store.dispatch('FedLogOut').then(() => {
              router.push('/login');
            },1500);
          });
          break;
        case 200015 :
          showMessage('ip没有权限,请登录')
          setTimeout(function () {
          router.push('/login');
          },1000);
          break;
        case 200016 :
          showMessage('当前机构用户暂无访问权限')
          setTimeout(function () {
          router.push('/login');
          },1000);
          break;
        default :
          showMessage(res.msg);
          break;
      }

      return Promise.reject('error')
    }
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 500 :
          showMessage('服务器错误，请稍后重试');
          // router.push('/401')
          break;
        default :
          showMessage();
          break;
      }
    }
    return Promise.reject(error)
  }
);

function showMessage(messages) {
  Message({
    message: messages,
    type: 'error',
    duration: 5 * 1000
  })
}

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js